// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueProgressBar from 'vue-progressbar'
import VueEvents from 'vue-events'
import VeeValidate from 'vee-validate'

import { Options } from './progress-bar-options.js'
import './styles/main.scss'

Vue.use(VueProgressBar, Options)
Vue.use(VeeValidate)
Vue.use(VueEvents)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js